import React from 'react';
import PropTypes from 'prop-types';

export default function Progress({ color, small, classModificator }) {
  const props = {
    className: `progress${ small ? ' progress--min-wrap': ''}${classModificator ? ` ${classModificator}`: ''}`,
    color: color || 'black'
  }

  return (
    <div {...props}>
        <div className="loading loadingMedium"></div>
    </div>
  );
}

Progress.propTypes = {
  small: PropTypes.bool,
  color: PropTypes.string
};

Progress.defaultProps = {
  small: true,
  color: 'black'
};
